if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        if (this.elements.thumbnails) {
          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });
          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        }

        this.initArrows();
      }

      initArrows() {
        const viewer = this.elements.viewer;
        if (!viewer) return;

        const tryInit = () => {
          const slider = viewer.querySelector('ul[id^="Slider-Gallery"]') || viewer.querySelector('.product__media-list');
          if (!slider) return;

          const getSlides = () => Array.from(slider.querySelectorAll('.product__media-item'));
          if (getSlides().length < 2) return;

          // Inject styles once
          if (!document.getElementById('media-gallery-arrow-styles')) {
            const styleEl = document.createElement('style');
            styleEl.id = 'media-gallery-arrow-styles';
            styleEl.textContent = `
              .media-gallery-arrow-wrapper {
                position: absolute;
                top: 0; left: 0;
                width: 100%; height: 100%;
                pointer-events: none;
                z-index: 10;
              }
              .media-gallery-arrow {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: auto;
                width: 3.8rem;
                height: 3.8rem;
                border-radius: 50%;
                border: 1px solid rgba(0,0,0,0.12);
                background: rgba(255,255,255,0.92);
                color: #1a1a1a;
                cursor: pointer;
                display: none;
                align-items: center;
                justify-content: center;
                padding: 0;
                box-shadow: 0 2px 8px rgba(0,0,0,0.14);
                transition: background 0.15s, color 0.15s, opacity 0.15s;
                backdrop-filter: blur(4px);
              }
              .media-gallery-arrow:hover {
                background: rgba(0,0,0,0.85);
                color: #fff;
              }
              .media-gallery-arrow--prev { left: 1.2rem; }
              .media-gallery-arrow--next { right: 1.2rem; }
              @media screen and (min-width: 750px) {
                .media-gallery-arrow { display: flex; }
              }
            `;
            document.head.appendChild(styleEl);
          }

          if (viewer.querySelector('.media-gallery-arrow-wrapper')) return;

          const wrapper = document.createElement('div');
          wrapper.className = 'media-gallery-arrow-wrapper';

          const prevBtn = document.createElement('button');
          prevBtn.type = 'button';
          prevBtn.className = 'media-gallery-arrow media-gallery-arrow--prev';
          prevBtn.setAttribute('aria-label', 'Previous image');
          prevBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>`;

          const nextBtn = document.createElement('button');
          nextBtn.type = 'button';
          nextBtn.className = 'media-gallery-arrow media-gallery-arrow--next';
          nextBtn.setAttribute('aria-label', 'Next image');
          nextBtn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>`;

          wrapper.appendChild(prevBtn);
          wrapper.appendChild(nextBtn);

          const viewerStyle = window.getComputedStyle(viewer);
          if (viewerStyle.position === 'static') viewer.style.position = 'relative';
          viewer.appendChild(wrapper);

          const updateArrowState = () => {};

          const navigate = (dir) => {
            const slides = getSlides();
            const currentIndex = slides.findIndex(s => s.classList.contains('is-active'));
            const targetIndex = (currentIndex + dir + slides.length) % slides.length;
            const targetSlide = slides[targetIndex];
            const mediaId = targetSlide.dataset.mediaId;
            if (mediaId) this.setActiveMedia(mediaId, false);
          };

          prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            navigate(-1);
          });
          nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            navigate(1);
          });

          [prevBtn, nextBtn].forEach((btn) => {
            btn.addEventListener('mousedown', (e) => e.stopPropagation());
            btn.addEventListener('touchend', (e) => e.stopPropagation());
          });

          // Keep arrow state in sync when thumbnails change the active slide
          viewer.addEventListener('slideChanged', () => updateArrowState());

          updateArrowState();
        };

        tryInit();
        setTimeout(tryInit, 0);
        setTimeout(tryInit, 300);
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}